import { NgModule } from '@angular/core';
import { NavigationEventModule } from '@spartacus/storefront';
import { ConsentEventModule } from './consent';

@NgModule({
  imports: [ConsentEventModule, NavigationEventModule],
})
export class EventsModule {}
